import CtaStepIndicator from './CtaStepIndicator';

export default CtaStepIndicator;



// WEBPACK FOOTER //
// ./src/components/atoms/CtaStepIndicator/index.js